import { UserPermission } from '@cobliteam/common-types/';

const MaintenancePermissions = {
  FULL_CONTROL_MAINTENANCE: UserPermission.FULL_CONTROL_MAINTENANCE,
  CREATE_UPDATE_DELETE_VEHICLE: UserPermission.CREATE_UPDATE_DELETE_VEHICLE,
};

export default MaintenancePermissions;
